import {Component, inject, OnInit} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {LogoComponent} from '../../../../shared/components/logo/logo.component';
import {Router, RouterOutlet} from '@angular/router';
import {SelectedAppointmentComponent} from '../selected-appointment/selected-appointment.component';
import {MatDivider} from '@angular/material/divider';
import {MemoryService} from '../../../../core/services/memory.service';
import {BookingLoginComponent} from '../login/booking-login.component';
import {ConfirmComponent} from '../confirm/confirm.component';
import {AppointmentSelectionService} from '../../../appointment-selection/appointment-selection.service';

@Component({
  selector: 'app-booking',
  imports: [
    LogoComponent,
    RouterOutlet,
    SelectedAppointmentComponent,
    MatDivider,
    BookingLoginComponent,
    ConfirmComponent
  ],
  templateUrl: './booking.component.html',
  styleUrl: './booking.component.scss'
})
export class BookingComponent implements OnInit {
  memoryService = inject(MemoryService);
  appointmentSelectionService = inject(AppointmentSelectionService);
  router = inject(Router);

  mode: 'mobile' | 'desktop' = 'desktop';

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 620px)',     // mobile
      '(min-width: 621px)'      // desktop
    ]).subscribe(result => {
      if (result.breakpoints['(max-width: 620px)']) {
        this.mode = 'mobile';
      } else if (result.breakpoints['(min-width: 621px)']) {
        this.mode = 'desktop';
      }
    });
  }

  ngOnInit(): void {
    if (this.appointmentSelectionService.timeSlotDto == null) {
      this.router.navigate(['/appointment-selection']);
    }
  }
}
